const register = {
  validating: {
    title: "Staðfesti boð",
  },
  titleInvitation: "Ljúktu við skráninguna þína",
  titleDefault: "Stofna aðgang",
  invitationBanner: {
    prefix: "Þér hefur verið boðið að taka þátt sem",
    forOrganization: "fyrir stofnunina",
    defaultOrganization: "stofnunina þína",
  },
  form: {
    emailLabel: "Netfang *",
    emailInvitationLocked: "Þetta netfang er ákveðið af boðinu þínu og er ekki hægt að breyta",
    emailHint: "Notaðu netfangið þitt hjá stofnuninni",
    nameLabel: "Fullt nafn *",
    institutionLabel: "Stofnun þín *",
    fromInvitation: "(úr boði)",
    institutionPlaceholder: "t.d. Landspítali",
    institutionInvitationLocked: "Stofnunin þín er ákveðin af boðinu þínu og er ekki hægt að breyta",
    institutionHint: "Hvar þú starfar (háskóli, sjúkrahús, rannsóknarsetur o.fl.)",
    passwordLabel: "Lykilorð *",
    passwordHint: "Að lágmarki 8 stafir",
    confirmPasswordLabel: "Staðfesta lykilorð *",
  },
  submitting: "Stofna aðgang...",
  submit: "Ljúka skráningu",
  signInLink: "Áttu nú þegar aðgang? Skrá inn",
  errors: {
    invalidInvitation: "Ógildur boðstengill",
    missingFields: "Fylla þarf út alla nauðsynlega reiti",
    piEmailRequired: "Vinsamlegast gefðu upp netfang ábyrgðarmanns verkefnisins (PI). Hann/hún yfirfer og samþykkir aðgangsbeiðnina þína.",
    passwordMismatch: "Lykilorðin stemma ekki",
    passwordTooShort: "Lykilorð verður að vera að minnsta kosti 8 stafir",
    registrationFailed: "Skráning mistókst",
  },
};

export default register;
